export default __webpack_public_path__ + "static/media/README.d797806d.md";